class PhoneFinder extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.fade = this.fade.bind(this)
    this.close = this.close.bind(this)
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(this.els.close.element, 'click', this.fade)
    this.listeners.add(this.els.link.element, 'click', this.click)
    this.listeners.add(this, 'transitionend', this.close)
    if (sessionStorage.getItem('phone-finder-hidden')) {
      this.els.container.element.setAttribute('aria-hidden', 'true')
    } else {
      this.els.container.element.setAttribute('aria-hidden', 'false')
    }
  }

  fade () {
    this.els.container.element.setAttribute('data-fade', 'true')
  }

  click () {
    const element = this.dataset.element
    if (!element) return

    window.dataLayer = window.dataLayer || []

    const data = {
      event: 'phone_finder_click',
      target_context: `phone_finder_${element}`,
    }

    window.dataLayer.push(data)
  }

  targetIsValid (e) {
    return (
      e.target === this.els.container.element && e.propertyName === 'opacity'
    )
  }

  close (e) {
    if (this.targetIsValid(e)) {
      this.els.container.element.setAttribute('aria-hidden', 'true')
      sessionStorage.setItem('phone-finder-hidden', 'true')
    }
  }
}

if (!customElements.get('phone-finder')) {
  customElements.define('phone-finder', PhoneFinder)
}
